import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-shijiegangkou",
  "use": "icon-shijiegangkou-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"icon-shijiegangkou\"><path d=\"M6.93 0a3.668 3.668 0 01.64 7.278V9.28h1.914v1.158H7.57v2.223a6.363 6.363 0 004.304-2.277l-1.067-.64 3.035-1.68-.057 3.468-.908-.546a7.521 7.521 0 01-5.306 2.837v1.816H6.413v-1.813a7.52 7.52 0 01-5.38-2.88l-.976.586L0 8.063l3.035 1.68-1.002.601a6.363 6.363 0 004.379 2.32v-2.227H4.468V9.279h1.944V7.297a3.668 3.668 0 01-3.147-3.526l-.002-.104A3.667 3.667 0 016.93 0zm0 1.158a2.509 2.509 0 000 5.018 2.509 2.509 0 000-5.018z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/shijiegangkou.svg
// module id = 503
// module chunks = 4